import { NgModule } from "@angular/core";
import { AccountsPayableEditProvider } from "./accounts-payable/accounts-payable-edit.provider";
import { AccountsPayableListProvider } from "./accounts-payable/accounts-payable-list.provider";
import { AccountsReceivableEditProvider } from "./accounts-receivable/accounts-receivable-edit.provider";
import { AccountsReceivableListProvider } from "./accounts-receivable/accounts-receivable-list.provider";
import { CompensatedListProvider } from "./compensated/compensated-list.provider";

export {
    AccountsPayableEditProvider, AccountsPayableListProvider, AccountsReceivableEditProvider,
    AccountsReceivableListProvider
};

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
        AccountsPayableListProvider,
        AccountsPayableEditProvider,
        AccountsReceivableEditProvider,
        AccountsReceivableListProvider,
        CompensatedListProvider
    ],
})
export class BondBackendModule { }
